import { Button, Modal, Form, Row, Col, message, Select } from "antd";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleAddToWishlist } from "../../../api/course";
import { handleFetchCompanyUser } from "../../../api/user";
import { useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";

const { Option } = Select;

export default function AssignWishlist({
  isVisible,
  setVisible,
  course_id,
}: any) {
  const { auth } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { data: users } = useQuery({
    queryKey: ["users", auth?.company?._id],
    queryFn: () => handleFetchCompanyUser({ _id: auth?.company?._id }),
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: handleAddToWishlist,
    onSuccess: () => {
      message.success("Allocated Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["courses", course_id] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { user } = await form.getFieldsValue();
    await mutate({ course_id, data: { user } });
    setVisible(false);
  };

  const userOptions = users?.payload?.map((level: any, index: number) => (
    <Option value={level?._id} key={index}>
      {level?.name}
    </Option>
  ));

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      open={isVisible}
      title="Assign To Wishlist"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="AssignToWishlist"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="AssignToWishlist"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-row, justify-between"></div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="user"
              label="Attendee"
              rules={[
                {
                  required: true,
                  message: "Please select attendee",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to Select Attendee"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {userOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
